<div #layer class="guided-tour-layer">
  <div #spotlight class="guided-tour-layer__spotlight" aria-hidden="true"></div>
  <div #bubble class="guided-tour-layer__bubble">
    <nr-guided-tour-step
      [step]="step()"
      [stepNumber]="stepNumber()"
      [stepCount]="stepCount()"
      (next)="next.emit()"
      (skip)="skip.emit()"
      (done)="done.emit()"
    ></nr-guided-tour-step>
  </div>
</div>
